export default __webpack_public_path__ + "static/media/page-v5-1.aceee5bd.png";